import React from "react";
import {useCustomerSubscriptionInfo} from "./useCustomerSubscriptionInfo";
import AnnouncementBar from "../AnnouncementBar";
import {Trans, useTranslation} from "react-i18next";

const CustomerSubscriptionInfoBar = (): React.ReactElement => {
  const {t} = useTranslation();
  const {hasSubscription} = useCustomerSubscriptionInfo();

  const urlParams = new URLSearchParams(window.location.search);
  const utmCampaign = urlParams?.get("utm_campaign");
  const isInvitedByFriend = utmCampaign && utmCampaign.indexOf("referralcandy") > -1;

  const referralCode = `FRIEND-${urlParams?.get("aic")}`;

  const isInfoBarVisible = hasSubscription;

  return (
    <>
      {isInfoBarVisible && (
        <div className="announcement-bar-container rounded-2 my-2">
          <div>{t("subscription.info_bar.already_existing_subscription")}</div>
          <div>
            <a
              href="/account"
              className="btn"
              style={{
                color: "rgb(255, 255, 255)",
                background: "rgb(80, 130, 175)",
                borderRadius: "24px",
              }}
              data-c="#ffffff"
              data-ac="#ffffff"
              data-bgc="#5082af"
              data-abgc="#232d41"
              data-hovercolors=""
            >
              {t("subscription.info_bar.look")}
            </a>
          </div>
        </div>
      )}
      {!isInfoBarVisible && isInvitedByFriend ? (
        <AnnouncementBar
          announcement={
            <Trans i18nKey="subscription.info_bar.referral_invite" values={{
              referralCode: referralCode,
              discountAmount: 30,
            }} components={{span: <span className="font-weight-bold" />}} />
          }
        />
      ) : null}
    </>
  );
};

export default CustomerSubscriptionInfoBar;
